<template>
	<div :style="{ textAlign: 'center' }">
		<div>
			{{ callbackText }}
		</div>
		<ve-pie :data="chartData" legend-position="bottom" :settings="settings"></ve-pie>
	</div>
</template>

<script>
	import defectService from '@/service/defectService'
	export default {
		props: {
			id: {
				type: String,
			},
		},
		data() {
			this.settings = {
				itemStyle: {
					normal: {
						label: {
							show: true,
							formatter: '{b} : {c} ({d}%)',
						},
						labelLine: { show: true },
					},
				},
			}
			return {
				callbackText: '',
				chartData: {},
				loading: false,
			}
		},
		methods: {
			loadingCallback(text) {
				this.callbackText = text
			},
			resize() {
				//重新出发resize事件
				if (document.createEvent) {
					var event = document.createEvent('HTMLEvents')
					event.initEvent('resize', true, true)
					window.dispatchEvent(event)
				} else if (document.createEventObject) {
					window.fireEvent('onresize')
				}
			},
		},
		created() {
			this.loading = true
			var p = defectService.getDefectStatByStatisIdAsync(this.id, this.loadingCallback)
			p.then(res => {
				var rows = []
				console.log('缺陷统计结果', res[0])
				var v = res[0]
				for (var attr in v) {
					if (attr == 'jt_id' || attr == 'jt_name') {
						continue
					}

					rows.push({
						type: attr,
						value: v[attr],
					})
				}

				this.chartData = {
					title: v.jt_name,
					columns: ['type', 'value'],
					rows: rows,
				}

				//重新出发resize事件
				if (document.createEvent) {
					var event = document.createEvent('HTMLEvents')
					event.initEvent('resize', true, true)
					window.dispatchEvent(event)
				} else if (document.createEventObject) {
					window.fireEvent('onresize')
				}

				this.loading = false
			})
		},
	}
</script>

<style></style>
